// src/components/ui/BrandSpinner.tsx
import React, { useState } from 'react';
import {
  GiCarrot,
  GiBroccoli,
  GiTomato,
  GiBanana,
  GiCookingPot,
  GiCutLemon,
  GiAvocado,
  GiAubergine,
  GiCheeseWedge,
  GiBreadSlice,
  GiCupcake 
} from 'react-icons/gi';

type IconComponent = React.ComponentType<React.SVGProps<SVGSVGElement>>;

const iconOptions: { Icon: IconComponent; colorClass: string }[] = [
  { Icon: GiCarrot, colorClass: 'text-orange-500' },
  { Icon: GiBroccoli, colorClass: 'text-green-500' },
  { Icon: GiTomato, colorClass: 'text-red-500' },
  { Icon: GiBanana, colorClass: 'text-yellow-400' },
  { Icon: GiCookingPot, colorClass: 'text-gray-600' },
  { Icon: GiCutLemon, colorClass: 'text-yellow-300' },
  { Icon: GiAvocado, colorClass: 'text-green-800' },
  { Icon: GiAubergine, colorClass: 'text-purple-900' },
  { Icon: GiCheeseWedge, colorClass: 'text-yellow-400' },
  { Icon: GiBreadSlice, colorClass: 'text-brown-300' },
  { Icon: GiCupcake, colorClass: 'text-pink-400' },
];

export const BrandSpinner: React.FC = () => {
  const [{ Icon, colorClass }] = useState(() => {
    const idx = Math.floor(Math.random() * iconOptions.length);
    return iconOptions[idx];
  });

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      {/* optional backdrop */}
      <div className="absolute inset-0" />
      <Icon className={`relative animate-spin-fast ${colorClass} text-4xl`} />
    </div>
  );
};

export default BrandSpinner;
